import { useQuery } from '@tanstack/react-query';

import { type QueryCollectionsArgs } from '@pkg/graphql/codegen/graphql';

import { callGetCollections } from '@app/client/resources/marketplace';

interface UseGetCollectionsArgs {
    variables: QueryCollectionsArgs;
    disabled?: boolean;
}
export function useGetCollections({ variables, disabled }: UseGetCollectionsArgs) {
    return useQuery({
        queryKey: ['gql-collections', ...Object.values(variables)],
        queryFn: ({ signal }) =>
            callGetCollections({
                settings: { signal },
                variables: {
                    ...variables,
                },
            }),
        enabled: !disabled,
        select: (res) => res?.data?.collections,
        staleTime: Infinity,
    });
}
